import { terminalOutput as officialTerminalOutput } from "@cs124/questioner-output";
import { Boolean, Record, String } from "runtypes";
import { printPoints } from "./points";
export const TerminalOutput = Record({
  error: Boolean,
  retry: Boolean,
  output: String
});
export const terminalOutput = (results, contents, options) => {
  const output = officialTerminalOutput(results, contents, options);
  const printedPoints = options.points ? `${printPoints(options.points)}

` : "";
  return {
    ...output,
    output: `${printedPoints}${output.output}`
  };
};
//# sourceMappingURL=output.js.map
